import Layout from '@components/layout';
import {
    AfishiPage,
    BronirovaniePage,
    CallsPage,
    CallsReportPage,
    PromoutersPage,
    BookingPage,
    ReservedTablesPage,
} from '@pages';
import { RouteConfig } from '@types';

export const booking = (): RouteConfig => {
    return {
        path: 'booking',
        element: <Layout />,
        redirect: 'reservation',
        children: [
            {
                path: 'reservation',
                element: <BookingPage />,
                navKey: 'booking.reservation',
            },
            {
                path: 'reserved-tables',
                element: <ReservedTablesPage />,
                navKey: 'reserved.tables',
            },
            {
                path: 'booking',
                element: <BronirovaniePage />,
                navKey: 'booking.report',
            },
            {
                path: 'callsreport',
                element: <CallsReportPage />,
                navKey: 'booking.callsreport',
            },

            {
                path: 'afishi',
                element: <AfishiPage />,
                navKey: 'booking.promo.afishi',
            },
            {
                path: 'reports',
                element: <CallsPage />,
                navKey: 'booking.reports',
            },
            {
                path: 'promouters',
                element: <PromoutersPage />,
                navKey: 'booking.promo.promouters',
            },
            { path: '', redirect: 'reservation' },
        ],
    };
};

export default booking;
